import { useState } from "react";
import { Card, CardBody } from "reactstrap";
import { Btn } from "../../../AbstractElements";
import { ToDoFilter } from "../../../utils/Constant";
import TodoNavBar from "./TodoNavBar";
import UserDetail from "./UserDetail";

const TodoSideBar = () => {
  const [showSideBar, setShowSideBar] = useState(false);
  return (
    <div className="email-sidebar md-sidebar">
      <Btn color="primary" className="email-aside-toggle md-sidebar-toggle" onClick={() => setShowSideBar(!showSideBar)}>
        {ToDoFilter}
      </Btn>
      <div className={`email-left-aside  custom-scrollbar md-sidebar-aside ${ showSideBar ? "open" : "" }`} >
        <Card>
          <CardBody>
            <div className="email-app-sidebar left-bookmark custom-scrollbar">
              <UserDetail />
              <TodoNavBar />
            </div>
          </CardBody>
        </Card>
      </div>
    </div>
  );
};

export default TodoSideBar;
